export enum BydTranslateEnum {
  DEFAULT_LANGUAGE = 'fr',
}
